import React from "react";
import ThermalPosPrintLayout from "./ThermalPosPrintLayout";

const ThermalPrint = React.forwardRef(({ data, printedTime }, ref) => {
    return (
        <div ref={ref}>
            <ThermalPosPrintLayout data={data} printedTime={printedTime} />
        </div>
    );
});

export default ThermalPrint;
